import { WinnersFeedSkeleton } from '@/components/markets/winners/winners-feed-skeleton';
import { Skeleton } from '@/components/ui/app-skeleton';
import { LISTING_INDEX_PAGE_STACK_CLASS } from '@/lib/ui/layout';
import { cn } from '@/lib/ui/utils';

const SORT_PILL_KEYS: readonly string[] = ['p0', 'p1', 'p2', 'p3', 'p4'];
const ACTION_KEYS: readonly string[] = ['a0', 'a1', 'a2', 'a3'];

// Route-level Suspense fallback — mirrors `WinnersPage`: the title + action
// icons header, the sort/filter pill bar, and the responsive `WinnersFeed`
// table. The body reflows identically to the loaded feed: an 8-column table
// (desktop header + grid rows) at lg+, and tall stacked stat cards below lg.
// Sized to the loaded layout so the skeleton→hydrated swap reads as the Winners
// page with minimal shift.
export default function WinnersLoading(): React.ReactNode {
  return (
    <div className={cn('w-full', LISTING_INDEX_PAGE_STACK_CLASS)}>
      <div className="flex items-center justify-between gap-2">
        <Skeleton className="h-7 w-32 shrink-0" />
        <div className="flex shrink-0 items-center gap-1">
          {ACTION_KEYS.map((key) => (
            <Skeleton key={key} className="size-9 rounded-control" />
          ))}
        </div>
      </div>

      <div className="flex items-center gap-2">
        {SORT_PILL_KEYS.map((key) => (
          <Skeleton key={key} className="h-9 w-28 shrink-0 rounded-control" />
        ))}
      </div>

      <WinnersFeedSkeleton />
    </div>
  );
}
